import { curry2 } from '@most/prelude';
export var complete = curry2(function complete(value, subject) {
    return subject.complete(value);
});
//# sourceMappingURL=complete.js.map